var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageGuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 240,
    viewBox: "0 0 159 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 238h158.48V.585H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M75.528 49.97v3.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.028 51.055c-.108 1.393.05 3.055 0 3M104.362 36.935c-1.5-2.166-5.167-4.333-8.5-4.5M77.862 32.769c-2.833.5-4.5 1.667-5.833 3.333M85.953 41.464c-3.183 3.344-5.894 14.73-5.258 19.258 3.55.179 6.078-.17 9.09.079",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.066 32.222c-.167 5-.047 16.317.667 19.167 1.384 5.52 4.008 9.479 4.83 15.004a38.385 38.385 0 0 0 5.628 15.032c1.498 2.336 4.708 4.797 8.875 5.13 2.914.234 19.167-3.5 25.667-25.5",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.066 39.889c2.333-2 5.993-1.915 8-.963 2.817 1.336 3.72 4.388 3.504 7.3-.453 6.11-4.423 10.653-9.708 13.45-1.367.724-2.129 1.213-4.129 1.713",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.733 46.889c-2.667 1.667-4.5 2.667-7 4.334",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.092 32.223c.369-3.493-1.192-9.221 1.142-17.661.442.845.833 1.859 1.296 2.595.87-1.988 2.037-5.655 3.037-7.988.198.907.97 2.289 1.334 3.112.85-2.195 3.332-5.78 4.999-7.446.334.536.543 2.1.867 2.645 1.4-.968 4.05-4.065 5.3-5.311.166-.166.833 1.5 1.54 2.67.109.179 3.6-3.502 3.96-3.504.308-.002 1 2.667 1.025 3.64 1.056.042 3.308-2.14 6.099-3.29.593 1.49 1.709 3.65 2.043 4.84.98-.998 2.666-2.523 4.166-3.856.535.948.148 4.1.797 4.82 1.203-1.32 2.203-2.32 3.919-3.424.593 1.48.384 3.205.82 4.754.9-.74 1.573-1.92 2.772-2.3.053 1.03-.17 2.359.184 3.258 1.323-.846 1.738-2.198 3.484-2.248 1.024 5.473.593 8.516.683 12.59.528-1.041 1.947-3.278 2.51-1.454.34 1.099-.483 3.278-.477 4.487.609-.277 2.712-1.384 2.783-.494.692 8.677-.943 16.279-1.141 15.898",
    fill: "#6D6063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.245 83.709c.867 3.681 1.965 8.221 1.988 8.208M114.793 59.952c1.424 3.942 6.648 16.298 10.023 16.923M97.362 72.889c-1.846-.074-5.833 1.667-7.333 4.334",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.525 85.727c-2.5 5.5-1.094 16.282 7.212 17.357 7.08.916 19.202-9.918 20.868-25.918",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.566 76.875c3.673.5 16.5 3 22.986 13.875 10.916 18.305 10.166 53.553 10.166 66.25 0 5.282-1.249 11.432-2.5 16.5-.595 2.411-5.787 13.822-8.5 13.75-18.75-.5-54.152-23.443-60.402-27.443M86.316 159.835c-5.667-3.166-14.78-1.247-22.25-2.086-3.836-.431-17.36-1.46-17.712-6.916 1.462-1.833 7.462 1.482 12.962 1.732",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.816 154.065c-2.313-.589-14.835 1.472-14.457-1.956 8.957-4.044 33.457-.237 47.957 4.141 6.055 1.828 26.902 7.25 34.402 10.75M132.284 115.563c3.935 19.854 3.155 41.385 3.155 48.885",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.066 153.608c.5 2.642-2.38 7.876-4.833 10.475M104.764 125.02c1.99 8.829 1.02 21.986.007 27.118",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.159 145.191c5.352 1.348 9.528 2.032 14.592 2.256 27.123 1.205 49.277.034 54.708-.974M84.343 202.178c1.815 8.867.943 20.606-.171 25.718M83.98 202.454c-1.089 3.606-29.491 3.876-30.505.554-1.182-3.864 30.142-4.438 30.868-1.109",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.375 202.343c-4.225 6.876-13.83 9.068-19.085 10.675-5.461 1.67-20.366 2.516-20.587 11.397 1.515 3.668 21.906 4.903 27.133 4.716M77.134 204.709c2.043 4.317 4.898 4.837 8.058 5.305",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.58 205.35c-4.181 2.909-10.141 7.02-15.706 8.738-5.946 1.834-11.98 3.263-14.308 9.08",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.351 220.986c5.324 1.453 9.486 2.212 14.545 2.545 27.617 1.82 48.912 0 54.718-.172",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.765 209.118c-5.133 5.147-7.294 10.756-8.914 14.297M53.964 208.38c-1.515-.92-2.218-.968-3.947-2.212M49.224 211.005c-1.331-1.091-1.996-1.161-3.105-2.253M43.783 212.952c-.602-.847-1.461-1.884-1.664-2.059M38.88 214.44a22.675 22.675 0 0 1-1.664-2.18M72.594 215.538c-1.72 8.23-10.943 4.456-8.675-1.907 2.075-5.818 8.957-4.222 8.866 1.458M19.037 185.381 1.132 209.374M88.43 209.374l14.566-24M88.6 236.949l14.566-24M102.997 185.374h-84.04M103.051 185.821v27.15M19.11 185.75v23.292",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)",
    d: "M.75 237.25h87.5v-27.5H.75zM37.091 178.463c5.046-1.94 9.027-4.391 13.833-7.874 3.173-2.3 6.644-7.174 12.978-12.508M80.606 161.54c-5.917 5.413-18.672 15.345-25.015 19.382M48.568 181.963c-.426-1.094-1.04-1.307-2.125-1.75-2.084.158-1.75 1.5-2.875 1.625-.875.125-1.5-1.625-3-2.125-2.375.5-1.487 1.68-3.25 1.625-2.192-.07-1.5-2.75-4.375-.25M54.091 180.838c2.5 1.584 8.365 1.849 8.981 2.63.644.816.155 1.756.375 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.091 183.588c2.218-.307 4.688-.197 6.878.122.886.129 1.895.218 1.997 1.253.105 1.076-.875 1.533-1.747 1.753-5.72 1.443-11.69 1.2-17.722 1.494-1.16.057-3.343.579-3.659-.994-.21-1.051 1.612-3.036 2.385-3.603 1.334-.978 3.312-.846 4.896-.9 2.093-.07 4.146.126 6.222.125",
    fill: "#FEFEFE",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.591 178.35c-4.625 2.25-8.293 4.94-9.666 8.056-1.92 4.36-3.167 12.682-.5 13.682 2.666-1 1.666-9.333 5.666-13.333.003 4.372-2.83 12.248.667 15 2.834-.563 1.832-12.15 5-15.334-.177 2.49-1.333 16.334 2 14.334 1.461-.877 1.005-12.236 4-14.667-.768 3.806-2.667 12.667 1 13 2.666-.667-.334-10.333 6.333-14.667M48.7 172.088c5.585.037 8.96 2.537 10.225 6M82.224 85.242c-3.625 2.665-6.569 6.751-8.077 13.431-.828 3.667-1.58 27.21-1.334 30.145M81.698 111.297c0 2.212.118 8.953.035 12.287M104.598 152.275c-2.167.667-7.086.891-9.46.83M80.793 158.5c-.25 7.185-.688 21-.688 26.25M62.566 115l-2.764-7.5M41.316 125.5l-5-4M29.066 147.647l-4.5.103M43.066 162.25l-3 4.5M89.411 104.953l-.095 7.547M117.618 109.014l-4.802 5.236M125.292 132.967l-8.726.265M121.038 154.542l-6.5-2M86.566 167.25l1.5 7",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.566 85.25c-6.975 2.483-9.088 9.956-9.875 16.25-1.125 9-.772 18.59-.875 26.25-.083 6.231-1.024 4 3.724 3.975 3.96-.022 8.803-.666 12.524.552 8.32 2.727 8.472 11.244 8.516 18.488.02 3.173-1.264 11.651-3.614 12.385-4.752 1.486-8.742-5.169-12.824-5.325-.659 8.591-1.099 32.475-1.099 40.567 0 9.509 2.046 11.581 10.646 14.294 14.273 4.503 51.213 2.304 53.794 2.539.036-2.01-.102-26.97.166-27.642.334-.833 1.458.59 2.306-.435 2.78-3.357 5.66-5.987 6.944-10.065 2.244-7.119 2.926-13.486 3.665-20.835 1.536-15.266-1.913-33.515-3.672-47.998-1.68-13.833-7.21-19.828-15.375-26.648-4.53-3.786-9.673-4.01-15.45-4.294-6.488-.32-13.229 3.573-18.5 2.942",
    fill: "#F69536",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.316 28.5c-.75 7.505-1.75 16.687.757 23.743 1.13 3.177 2.593 6.668 3.618 9.882 1.096 3.438 1.753 7.112 2.681 10.625 1.043 3.951 3.778 9.262 7.195 11.75 2.141 1.56 4.957 1.888 7.5 1.556 2.313-.303 4.478-2.277 6.711-2.268.117.74.804 1.61.788 2.296-.027 1.211-.86 2.2-1 3.416-.216 1.878-.022 4.268.375 6 .771 3.363 3.281 6.637 6.75 7.5 7.024 1.747 12.625-4.5 16.562-10.263 2.001-2.93 3.59-6.31 4.257-9.793.21-1.096 1.371-4.279 1.068-5.194-.43-1.294-1.712-2.026-2.512-3.25-2.125-3.25-3.892-5.985-5-9.125-.54-1.532-2.593-4.272-1.687-5.824.588-1.007 2.984-2.007 3.937-2.801 4.836-4.031 8.005-15.633.806-18.556-3.848-1.561-12.89-6.397-14.482-9.445-2.206-4.225-7.236-7.563-11.819-8.555-6.73-1.456-23.625-2.774-26.005 6.056",
    fill: "#FEF398",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.233 31.417c3-6 9.336-12.223 21-11.667 10.5.5 17.815 8.187 19.895 15.237.605 2.055.188 5.55.188 9.263 0 .001 2.732.165 2.75.083.459-1.999.417-3.291 2.5-4.75 1.746-1.223 4.655-2.277 6.712-1.427-.812-13.066-13.828-20.886-26.15-22.669-5.092-.737-11.56-1.565-16.562-.237-2.436.646-7.151 2.816-8.694 5.056-.865 1.255-.93 2.829-1.306 4.194",
    fill: "#6D6063",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.528 66.78c3.416 0 15.65-3.388 15.833 1.275.334 8.5-8.787 10.964-13.166 8.667-2.513-1.318-7.672-9.288-2.334-9.834",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9 66.251c3.08.002 10.083-1.5 11.485-.069 2.51 2.562-.224 8.269-2.735 9.902-2.763 1.797-6.547 1.82-9.527.104-2.126-1.225-5.83-6.027-4.056-8.437 1.157-1.572 1.583-1 5.75-1.501",
    fill: "#F0612B",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.406 125.302c-1.018 3.628-27.623 4.46-28.704 1.159-1.257-3.84 28.265-5.034 29.057-1.72",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.618 125.798c-4.801 7.452-15.46 9.34-20.682 11.05-5.427 1.779-20.312 2.922-20.358 11.804.777 1.778 6.047 2.884 11.844 3.518M97.607 127.692c2.128 4.276 4.993 4.74 8.161 5.144",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.853 128.701c-4.787 4.3-11.784 7.22-17.314 9.048-5.909 1.951-11.913 3.5-14.125 9.361M102.324 132.01c-4.882 5.638-6.982 12.137-8.053 15.228",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.524 131.738c-1.532-.89-2.236-.925-3.99-2.135M71.356 134.455c-1.352-1.064-2.019-1.12-3.149-2.19M65.586 136.963c-.618-.834-2.12-2.222-2.327-2.393M59.553 138.18a22.614 22.614 0 0 1-1.707-2.146M93.282 138.61c-1.556 8.26-10.853 4.671-8.71-1.736 1.959-5.857 8.87-4.399 8.892 1.282",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.19 124.855c1.627 10.628.108 26.776-.294 27.132-3.707 3.263-40.022-.255-44.824.518-2.642.424-13.529-4.715-12.642-.237-3.042-.03-12.212-.911-12.956-4.014-.782-3.254 6.277-7.314 9.415-8.266 4.788-1.453 9.075-2.321 13.925-3.613 4.072-1.083 9.577-2.388 12.75-5 4.167-3.427 6.602-7.394 12.25-8.055 5.626-.656 13.72-1.356 19.126-.07",
    fill: "#FEFEFE",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 153.751c.278 4.171-2.254 6.945-4.75 9.949-3.458-1.45-8.255-4.898-11.833-5.575-4.38-.827-8.098.338-12.418-.04-4.23-.37-23.913-1.119-22.95-7.617 4.31-.363 8.877 2.305 12.534 1.532 2.027-.428 3.196-1.491 5.75-1.583 2.415-.087 4.919-.078 7.334 0 10.333.334 21.833 2.501 25 3.667",
    fill: "#FEF398",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.647 124.944c0 1.553-6.559 3.521-14.651 3.521-5.194 0-15.141-.006-14.651-2.813.083-.479 6.559-2.812 14.651-2.812 8.092 0 14.651.551 14.651 2.104",
    fill: "#F0612B",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.816 185C16.82 189.489 2.141 206.366.104 211.187c1.6 1.173 4.035 1.118 6.024 1.5 2.98.575 5.75 1.741 8.7 2.312 5.081.985 11.607 1.469 16.726 1.25 8.034-.343 15.665-1.079 23.69-.755 5.574.226 11.21.206 16.827.256 3.707.033 5.294.346 7.801 2.438 2.271 1.896 3.462 2.239 4.181 5.062.534 2.093 1.11 4.135 1.5 6.25.63 3.398 1.908 9.744 5.201 4.438 3.557-5.734 12.145-20.521 12.312-20.688.118-.118 0-28-.333-28-4.156 0-48.6.601-52.667-.001-4.729-.7-9.263.001-14.063.001-2.895 0-5.792.034-8.687 0-1.469-.018-2.81-.254-4.25-.25a28.8 28.8 0 0 0-2 .056c-.48.035-1.975.627-1.25.194",
    fill: "#68493B",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.733 178.084c-1.505.745-2.962 1.896-4.308 2.592 3.308 2.242 7.557.924 7.599 4.024-3.922.199-10.958.218-13.374 1.709-3.511 2.167-1.777 8.742-3.227 12.299-4.27-.234-1.747-9.486-1.757-11.923-3.626 2.689-1.85 12.09-3.975 13.715-3.85 2.943-1.647-12.398-2.024-14.39-2.134 2.388-2.852 14.757-4.601 15.14-4 .875-.922-12.859-1.058-14.455-3.02 1.507-2.28 12.374-5.267 12.645-3.836.35-.247-12.05.733-13.615 2.245-3.584 6.976-6.214 10.51-8.157 3.444-1.894 9.416-5.75 10.749-5.584 3.516.438 7.583 2.166 10 6",
    fill: "#FEF398",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.441 209.375c0-2.002-.47-4.332-.875-6.208-.44-2.041-1.43-2.428-3.372-2.92-3.752-.951-8.282-.247-12.253-.247-2.078 0-4.174-.084-6.25 0-2.003.081-5.32.356-7.125 1.25-1.833.908-1.599 1.396-2.875 2.875-1.255 1.455-3.288 3.116-4.958 3.958-1.294.652-2.917 1-4.275 1.771 1.775.324 4.278.021 6.108.021 2.018 0 3.95-.25 6-.25 4.231 0 8.297.04 12.497.25 2.922.146 5.998-.232 8.878-.375a45.946 45.946 0 0 1 4.5 0c1.325.067 3.091-.117 4.375.25",
    fill: "#FEFEFE",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.624 202.459c0 1.541-7.007 2.791-15.65 2.791s-15.325-1.209-15.325-2.75c0-1.542 6.682-2.833 15.325-2.833 8.642 0 15.65 1.25 15.65 2.792",
    fill: "#F0612B",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.066 157.375a58.808 58.808 0 0 0-7.372 7.372c-1.05 1.252-2.168 2.399-3.284 3.597-1.057 1.135-2.522 1.915-3.456 3.131 1.782.397 3.648 1.076 5.212 2.181 1.781 1.259 2.46 2.948 3.303 4.703 1.582-.778 2.916-2.052 4.597-2.89 1.932-.963 3.875-1.991 5.631-3.317 2.922-2.202 5.61-4.859 8.4-7.246 1.403-1.2 2.614-1.906 3.122-3.656.156-.537.801-2.362.481-2.881-.413-.669-2.16-.529-2.884-.494-4.067.2-8.389-.07-12.375.125-.347.017-1.183 0-1.25 0",
    fill: "#F69536",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C7141",
    mask: "url(#b)",
    d: "m102.733 185.25-14.483 24.5v27.5l14.816-24z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)",
    d: "M75.528 49.555v3.5M97.028 51.055c-.108 1.393.05 3.055 0 3M104.362 36.935c-1.5-2.166-5.167-4.333-8.5-4.5M77.862 32.769c-2.833.5-4.5 1.667-5.833 3.333M85.953 41.464c-3.183 3.344-5.894 14.73-5.258 19.258 3.55.179 6.078-.17 9.09.079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.066 32.222c-.167 5-.047 16.317.667 19.167 1.384 5.52 4.008 9.479 4.83 15.004a38.385 38.385 0 0 0 5.628 15.032c1.498 2.336 4.708 4.797 8.875 5.13 2.914.234 19.167-3.5 25.667-25.5",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.066 39.889c2.333-2 5.993-1.915 8-.963 2.817 1.336 3.72 4.388 3.504 7.3-.453 6.11-4.423 10.653-9.708 13.45-1.367.724-2.129 1.213-4.129 1.713",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.733 46.889c-2.667 1.667-4.5 2.667-7 4.334M67.092 32.223c.369-3.493-1.192-9.221 1.142-17.661.442.845.833 1.859 1.296 2.595.87-1.988 2.037-5.655 3.037-7.988.198.907.97 2.289 1.334 3.112.85-2.195 3.332-5.78 4.999-7.446.334.536.543 2.1.867 2.645 1.4-.968 4.05-4.065 5.3-5.311.166-.166.833 1.5 1.54 2.67.109.179 3.6-3.502 3.96-3.504.308-.002 1 2.667 1.025 3.64 1.056.042 3.308-2.14 6.099-3.29.593 1.49 1.709 3.65 2.043 4.84.98-.998 2.666-2.523 4.166-3.856.535.948.148 4.1.797 4.82 1.203-1.32 2.203-2.32 3.919-3.424.593 1.48.384 3.205.82 4.754.9-.74 1.573-1.92 2.772-2.3.053 1.03-.17 2.359.184 3.258 1.323-.846 1.738-2.198 3.484-2.248 1.024 5.473.593 8.516.683 12.59.528-1.041 1.947-3.278 2.51-1.454.34 1.099-.483 3.278-.477 4.487.609-.277 2.712-1.384 2.783-.494.692 8.677-.943 16.279-1.141 15.898M96.245 83.709c.867 3.681 1.965 8.221 1.988 8.208M114.793 59.952c1.424 3.942 6.648 16.298 10.023 16.923M82.528 66.893c2.788-.142 15.65-3.5 15.833 1.163.334 8.5-8.787 10.964-13.166 8.667-2.513-1.318-7.672-9.288-2.334-9.834",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.362 72.889c-1.846-.074-5.833 1.667-7.333 4.334M96.525 85.727c-2.5 5.5-1.094 16.282 7.212 17.357 7.08.916 19.202-9.918 20.868-25.918",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.566 76.875c3.673.5 16.5 3 22.986 13.875 10.916 18.305 10.166 53.553 10.166 66.25 0 5.282-1.249 11.432-2.5 16.5-.595 2.411-5.787 13.822-8.5 13.75-18.75-.5-54.152-23.443-60.402-27.443M86.316 159.835c-5.667-3.166-14.78-1.247-22.25-2.086-3.836-.431-17.36-1.46-17.712-6.916 1.462-1.833 7.462 1.482 12.962 1.732",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.816 154.065c-2.313-.589-14.835 1.472-14.457-1.956 8.957-4.044 33.457-.237 47.957 4.141 6.055 1.828 26.902 7.25 34.402 10.75M132.284 115.563c3.935 19.854 3.155 41.385 3.155 48.885",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.066 153.608c.5 2.642-2.38 7.876-4.833 10.475M104.764 125.02c1.99 8.829 1.02 21.986.007 27.118M104.406 125.302c-1.018 3.628-27.623 4.46-28.704 1.159-1.257-3.84 28.265-5.034 29.057-1.72",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.618 125.798c-4.801 7.452-15.46 9.34-20.682 11.05-5.427 1.779-20.312 2.922-20.358 11.804.777 1.778 6.047 2.884 11.844 3.518M97.664 127.89c2.128 4.277 4.936 4.542 8.104 4.946",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.853 128.701c-4.787 4.3-11.784 7.22-17.314 9.048-5.909 1.951-11.913 3.5-14.125 9.361",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.159 145.191c5.352 1.348 9.528 2.032 14.592 2.256 27.123 1.205 49.277.034 54.708-.974",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 132.378c-4.882 5.638-6.84 11.769-7.91 14.859M76.524 131.738c-1.532-.89-2.236-.925-3.99-2.135M71.356 134.455c-1.352-1.064-2.019-1.12-3.149-2.19M65.586 136.963c-.618-.834-2.12-2.222-2.327-2.393M59.553 138.18a22.614 22.614 0 0 1-1.707-2.146M93.282 138.61c-1.556 8.26-10.853 4.671-8.71-1.736 1.959-5.857 8.87-4.399 8.892 1.282M84.343 202.178c1.815 8.867.943 20.606-.171 25.718M83.98 202.454c-1.089 3.606-29.491 3.876-30.505.554-1.182-3.864 30.142-4.438 30.868-1.109",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.375 202.343c-4.225 6.876-13.83 9.068-19.085 10.675-5.461 1.67-20.366 2.516-20.587 11.397 1.515 3.668 21.906 4.903 27.133 4.716M77.134 204.709c2.043 4.317 4.898 4.837 8.058 5.305",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.58 205.35c-4.181 2.909-10.141 7.02-15.706 8.738-5.946 1.834-11.98 3.263-14.308 9.08",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.351 220.986c5.324 1.453 9.486 2.212 14.545 2.545 27.617 1.82 48.912 0 54.718-.172",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.765 209.43c-5.133 5.147-7.294 10.444-8.914 13.985M53.964 208.38c-1.515-.92-2.218-.968-3.947-2.212M49.224 211.005c-1.331-1.091-1.996-1.161-3.105-2.253M43.783 212.952c-.602-.847-1.461-1.884-1.664-2.059M38.88 214.44a22.675 22.675 0 0 1-1.664-2.18M72.594 215.538c-1.72 8.23-10.943 4.456-8.675-1.907 2.075-5.818 8.957-4.222 8.866 1.458M19.037 185.381 1.132 209.374M88.43 209.374l14.566-24M88.6 236.949l14.566-24M102.997 185.374h-84.04M103.051 185.821v27.15M19.11 185.75v23.292",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C7141",
    mask: "url(#b)",
    d: "M.75 237.25h87.5v-27.5H.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)",
    d: "M.75 237.25h87.5v-27.5H.75zM37.091 178.463c5.046-1.94 9.027-4.391 13.833-7.874 3.173-2.3 6.644-7.174 12.978-12.508M80.606 161.54c-5.917 5.413-18.672 15.345-25.015 19.382M48.568 181.963c-.426-1.094-1.04-1.307-2.125-1.75-2.084.158-1.75 1.5-2.875 1.625-.875.125-1.5-1.625-3-2.125-2.375.5-1.487 1.68-3.25 1.625-2.192-.07-1.5-2.75-4.375-.25M54.091 180.838c2.5 1.584 8.365 1.849 8.981 2.63.644.816.155 1.756.375 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.091 183.588c2.218-.307 4.688-.197 6.878.122.886.129 1.895.218 1.997 1.253.105 1.076-.875 1.533-1.747 1.753-5.72 1.443-11.69 1.2-17.722 1.494-1.16.057-3.343.579-3.659-.994-.21-1.051 1.612-3.036 2.385-3.603 1.334-.978 3.312-.846 4.896-.9 2.093-.07 4.146.126 6.222.125",
    fill: "#FEF398",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.591 178.35c-4.625 2.25-8.293 4.94-9.666 8.056-1.92 4.36-3.167 12.682-.5 13.682 2.666-1 1.666-9.333 5.666-13.333.003 4.372-2.83 12.248.667 15 2.834-.563 1.832-12.15 5-15.334-.177 2.49-1.333 16.334 2 14.334 1.461-.877 1.005-12.236 4-14.667-.768 3.806-2.667 12.667 1 13 2.666-.667-.334-10.333 6.333-14.667M48.7 172.088c5.585.037 8.96 2.537 10.225 6M82.224 85.242c-3.625 2.665-6.569 6.751-8.077 13.431-.828 3.667-1.58 27.21-1.334 30.145M81.698 111.297c0 2.212.118 8.953.035 12.287M104.598 152.275c-2.167.667-7.086.891-9.46.83M80.793 158.5c-.25 7.185-.688 21-.688 26.25M62.566 115l-2.764-7.5M41.316 125.5l-5-4M29.066 147.647l-4.5.103M43.066 162.25l-3 4.5M89.411 104.953l-.095 7.547M117.618 109.014l-4.802 5.236M125.292 132.967l-8.726.265M121.038 154.542l-6.5-2M86.566 167.25l1.5 7",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#010202",
    strokeWidth: 1.5,
    mask: "url(#b)",
    d: "m102.567 214.996 42.122.237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.566 187.231c0 2.875.095 24.101 0 28.002",
    stroke: "#010202",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageGuy);
export default __webpack_public_path__ + "static/media/package_guy.e5d68ea4c0fa962e2872e0e010c34eff.svg";
export { ForwardRef as ReactComponent };